// @mui
import PropTypes from 'prop-types';
import { RadioGroup } from '@mui/material';
//
import SvgColor from '../../svg-color';
import { useSettingsContext } from '../SettingsContext';
import { StyledCard, StyledWrap, MaskControl } from '../styles';

// ----------------------------------------------------------------------

const OPTIONS = ['light', 'dark', 'system'];

/**
 * Theme mode selector. Pass horizontal={true} to layout icons in a row.
 */
ModeOptions.propTypes = {
  horizontal: PropTypes.bool,
};

export default function ModeOptions({ horizontal = false }) {
  const { themeMode, onChangeMode } = useSettingsContext();

  return (
    <RadioGroup name="themeMode" value={themeMode} onChange={onChangeMode}>
      <StyledWrap
        sx={{
          gridTemplateColumns: horizontal
            ? `repeat(${OPTIONS.length}, auto)`
            : 'repeat(1, 1fr)'
        }}
      >
        {OPTIONS.map((mode) => (
          <StyledCard key={mode} selected={themeMode === mode}>
            <SvgColor
              src={`/assets/icons/setting/${
                mode === 'light' ? 'ic_sun' : mode === 'dark' ? 'ic_moon' : 'ic_setting'
              }.svg`}
            />
            <MaskControl value={mode} />
          </StyledCard>
        ))}
      </StyledWrap>
    </RadioGroup>
  );
}
